import fvAxios from "../../utils/fvAxios";
import BaseUrl from "../../utils/base-uri.json";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { setInvitationURL, setInvitationVendorId, setInvitationClientId, setInvitationIsMultiClient, setInvitationPqid } from "../../utils/Token";

function ImportInvitationsToFV() {
    const location = useLocation();
    const search = location.search;
    const allowedPath = ["/Common/ImportInvitationsToFV"];

    useEffect(() => {
        if (allowedPath?.indexOf[location?.pathname] !== -1) {
            fvAxios
                .get(BaseUrl.baseUrl + location?.pathname?.substring(1) + search)
                .then((resp) => {
                    console.log(resp?.data?.data);
                })
                .catch((err) => { });
        } else {
            window.location = "/";
        }
    }, [location.pathname, allowedPath, search]);
}

export default ImportInvitationsToFV